module.exports = __webpack_public_path__ + "./AnniePhoto_ec00cf74d583436a3dee3672d8788058.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/AnniePhoto.png
// module id = 491
// module chunks = 0